import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { sectionZeroV0Schema } from './v0';
import { sectionLegacyDefaultV0Schema } from '../legacy/default';
import { migrateLegacyZeroToV0 } from '../legacy/migration';

/**
 * A zero row's legacy shape is the ordinary one — the registry routes here off
 * the parent block, not off anything in the section itself.
 */
export const ZeroSectionEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: sectionZeroV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: sectionLegacyDefaultV0Schema, up: migrateLegacyZeroToV0 }],
});

export type ZeroSection = InferredEntity<typeof ZeroSectionEntitySchema>;
